import { Outlet, Link, useLocation } from 'react-router-dom';

export default function Layout() {
  const location = useLocation();
  const isSubmitPage = location.pathname === '/submit';

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-parchment-100/90 backdrop-blur-sm border-b border-parchment-300">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-2xl font-serif font-semibold text-gray-900">
              Wall of Regrets
            </span>
          </Link>

          <nav className="flex items-center gap-4">
            <Link
              to="/random"
              className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
            >
              Random
            </Link>
            <Link
              to="/faq"
              className="text-gray-600 hover:text-gray-900 font-medium transition-colors"
            >
              FAQ
            </Link>
            {!isSubmitPage && (
              <Link to="/submit" className="btn btn-primary">
                Add yours — $1
              </Link>
            )}
          </nav>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="border-t border-parchment-300 py-8 mt-12">
        <div className="max-w-7xl mx-auto px-4 text-center text-gray-500 text-sm">
          <p>Every regret is anonymous and permanent.</p>
          <p className="mt-2">
            <Link to="/" className="hover:text-gray-900">The Wall</Link>
            {' · '}
            <Link to="/random" className="hover:text-gray-900">Random</Link>
            {' · '}
            <Link to="/submit" className="hover:text-gray-900">Submit</Link>
            {' · '}
            <Link to="/faq" className="hover:text-gray-900">FAQ</Link>
          </p>
        </div>
      </footer>
    </div>
  );
}
